module.exports = __webpack_public_path__ + "img/reliable.1d83beb5.svg";